import { createUseStyles } from 'react-jss';

const styles = {
  header: {
    position: 'relative',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: { top: '5.6rem', bottom: '5.2rem' },
  },
  title: {
    margin: { top: 0, bottom: '0.8rem' },
    font: { size: '3.4rem', lineHeight: '4rem', weight: 700 },
    letterSpacing: '0.02rem',
  },
  caption: {
    margin: '0 auto 1.2rem',
    font: { size: '1.8rem', lineHeight: '2.8rem' },
    letterSpacing: '0.02rem',
    maxWidth: '70%',
  },
  backButton: {
    position: 'absolute',
    left: 0,
    top: '2.6rem',
    paddingLeft: 0,
    '&:disabled': {
      textTransform: 'none',
    },
  },
  backButtonInLine: { top: '0.7rem' },
};

const createStyles = createUseStyles(styles);

export { createStyles };
